import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import CSLoading from "../../../../components/common/CSLoading";
import Response from "../../../../components/Habitacional/core/Response/Response";
import TrackingStatus from "../../../../components/Habitacional/core/TrackingStatus";

import useAuthToken from "../../../../hooks/requests/useAuthToken";

import { envs } from "../../../../config";

const TrackingStatusPage = () => {
  const { query } = useParams();
  const { refreshToken } = useAuthToken();

  const [pedidos, setPedidos] = useState([]);
  const [failedRequest, setFailedRequest] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let params = "";

    if (query.length === 11) {
      params = `cpfSegurado=${query}`;
    } else {
      params = `NumeroComunicado=${query}`;
    }

    refreshToken().then((token) => {
      const myHeaders = new Headers();
      myHeaders.append("X-IBM-Client-Id", envs.clientId);
      myHeaders.append("Authorization", `Bearer ${token}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const url = `${envs.hostApic}/segurohabitacional/v1/sinistro/pesquisas/comunicados?${params}`;

      fetch(url, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.response.length > 0) return setPedidos(result.response);
          throw Error();
        })
        .catch(() => setFailedRequest(true))
        .finally(() => {
          setIsLoading(false);
        });
    });
  }, [query, refreshToken, setPedidos]);

  if (isLoading) {
    return <CSLoading center />;
  }

  return (
    <>
      {!failedRequest && !isLoading && <TrackingStatus pedidos={pedidos} />}
      {failedRequest && <Response />}
    </>
  );
};

export default TrackingStatusPage;
